module.exports = __webpack_public_path__ + "static/media/kh.25b4be5d.svg";